// Availability.js
import axiosInstance from '@/lib/axios';




export async function eventPOST(data) {
  try {

    console.log(data)
    const response = await axiosInstance.post('/users/events', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    }
    throw new Error(error.message);
  }
}


export async function eventGET(status = "all") {
  try {
    const response = await axiosInstance.get('/users/events/all', {
      params: { status }  // <-- query param appended as ?status=all
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    }
    throw new Error(error.message);
  }
}


export async function eventGET_ID(event_id) {
  try {
    const response = await axiosInstance.get(`/users/events/all/${event_id}`);


    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    }
    throw new Error(error.message);
  }
}







export async function myEventsGET() {
  try {
    const response = await axiosInstance.get('/users/events/me');
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    }
    throw new Error(error.message);
  }
}

export async function eventPATCH(data) {
  const payload = {
    id: data.id,
    event_name: data.event_name,
    event_date: data.event_date,
    time_range: data.time_range,
    description: data.description,
    venue: data.venue,
    max_participants: data.max_participants,
    permission: data.permission,
    address: data.address,
  };

  const response = await axiosInstance.patch('/users/events', payload);


  return response.status === 204 ? null : response.data;

}

export async function eventDELETE(data) {

  const response = await axiosInstance.delete(`/users/events/${data.id}`, { data });

  return response

}












/**
 * 
 * BACKUP
 * // Availability.js
import axiosInstance from '@/lib/axios';




export async function eventPOST(data) {
  try {

    console.log(data)
    const response = await axiosInstance.post('/users/events', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    }
    throw new Error(error.message);
  }
}

export async function eventGET() {
  try {
    const response = await axiosInstance.get('/users/events');
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    }
    throw new Error(error.message);
  }
}

export async function myEventsGET() {
  try {
    const response = await axiosInstance.get('/users/events/me');
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    }
    throw new Error(error.message);
  }
}

export async function eventPATCH(data) {
  const payload = {
    id: data.id,
    event_name: data.event_name,
    event_date: data.event_date,
    time_range: data.time_range,
    description: data.description,
    venue: data.venue,
    max_participants: data.max_participants,
    permission: data.permission,
    address: data.address,
  };

  const response = await axiosInstance.patch('/users/events', payload);


  return response.status === 204 ? null : response.data;

}

export async function eventDELETE(data) {

  const response = await axiosInstance.delete(`/users/events/${data.id}`, { data });

  return response

}












 * 
 */